import React, { useState, useEffect, useContext } from "react";
import "./Benefits.css";
import { Benefit } from "../../../utils/apis/subsidy-policy/SubsidyPolicy";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
// import { Pagination } from "react-bootstrap";

const Benefits = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [benefit, setBenefit] = useState([]);

  const getBenefit = async () => {
    const res = await Benefit();

    if (res?.success) {
      setBenefit(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBenefit();
  }, []);

  const subsidyCards = [
    {
      title: "Subsidy for GHS/RWA",
      subtitle: "(Group Housing Society/Resident Welfare Association)",
      amount: "Rs. 18,000 per kW",
      text:
        "for common facilities, including EV charging, up to 500 kW Capacity(@3 kW per house) with the upper limit being inclusive of individual rooftop plants installed by individual residents in the GHS/RWA",
    },
    {
      title: "Subsidy for GHS/RWA",
      subtitle: "(Group Housing Society/Resident Welfare Association)",
      amount: "Rs. 18,000 per kW",
      text:
        "for common facilities, including EV charging, up to 500 kW Capacity(@3 kW per house) with the upper limit being inclusive of individual rooftop plants installed by individual residents in the GHS/RWA",
    },
    {
      title: "Subsidy for GHS/RWA",
      subtitle: "(Group Housing Society/Resident Welfare Association)",
      amount: "Rs. 18,000 per kW",
      text:
        "for common facilities, including EV charging, up to 500 kW Capacity(@3 kW per house) with the upper limit being inclusive of individual rooftop plants installed by individual residents in the GHS/RWA",
    },
  ];

  return (
    <section className="Benefits">
      <div className="container-fluid">
        <div className="Benefits_header_holder">
          <h5 className="Benefits_title">Benefits</h5>
          <p className="Benefits_subtitle">
            Latest updates, announcements, and important information at a
            glance.
          </p>
        </div>

        <div className="Benefits_content_div">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-12">
              <>
                <div className="col-lg-12 col-md-12">
                  <div className="upper_col_holder">
                    <p className="upper_col_text">
                      {" "}
                      Subsidy for <br /> Residential Households
                    </p>
                  </div>
                </div>
                <div className="row mt-3">
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={3}
                    autoplay={{
                      delay: 2500,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    loop={true}
                    pagination={{
                      clickable: true,
                    }}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      576: { slidesPerView: 2 },
                      992: { slidesPerView: 3 },
                    }}
                  >
                    {benefit.slice(0, 6).map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="lower_col_holder">
                          <h5 className="lower_col_number">{item.amount}</h5>
                          <p className="lower_col_kw">{item.subtitle}</p>
                          <p className="lower_col_text">
                            {htmlToReactParser.parse(item.description)}
                          </p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            </div>

            <div className="col-lg-5 col-md-12 col_swiper">
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={true}
                allowTouchMove={benefit.slice(3).length > 1}
              >
                {benefit.slice(3).map((item, index) => (
                  <SwiperSlide key={item.id || index}>
                    <div className="right_col_holder">
                      <h5 className="right_col_title">{item.name}</h5>
                      <p className="right_col_subtitle">{item.subtitle}</p>
                      <h5 className="right_col_kw">{item.amount}</h5>
                      <p className="right_col_text">
                        {htmlToReactParser.parse(item.description)}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
